import React from 'react';
import PropTypes from 'prop-types';
import EmailNameInputComponent from '../EmailNameInputComponent';

const HeroSection = ({ heading, subheading, buttonText, buttonBgColor }) => {
  return (
    <div className="relative text-center px-7 py-14 pt-16 md:py-12 lg:py-14 md:px-16 lg:px-36 xl:px-44 2xl:px-60">
      <div className="max-w-7xl mx-auto">
        <h1 className="
          text-[2.5rem] lg:text-[3.25rem] leading-[3.125rem] lg:leading-[3.875rem]
          text-white font-bold mb-6 break-words
        ">
          {heading}
        </h1>
        {subheading && (<p className="font-semibold text-white lg:text-[1.375rem] leading-[1.875rem] mb-7">
          {subheading}
        </p>)}
        <EmailNameInputComponent
          id="1"
          className="w-full lg:w-3/4 lg:mx-auto"
          buttonText={buttonText}
          buttonBgColor={buttonBgColor}
        />
      </div>
      <div className="text-center text-white text-sm mt-6  mb-8">
        Travel is scheduled for October 2025. Additional runner-up prizes
        will be awarded. No purchase necessary to enter. Sweepstakes closes July 16, 2025.
      </div>
    </div>
  );
};

HeroSection.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string,
  buttonBgColor: PropTypes.string
};

export default HeroSection;
